export const ARTICLES_LOAD_LIST = 'articles@load-list';
export const ARTICLES_SET_NOW_LOADING = 'articles@set-now-loading';
export const ARTICLES_SET_LIST = 'articles@set-list';
export const ARTICLES_PUSH_TO_LIST = 'articles@push-to-list';
export const ARTICLES_SET_ACTIVE_ID = 'articles@set-active-article-id';
export const ARTICLES_FETCH_ARTICLE = 'articles@fetch-article';
export const ARTICLES_REPLACE_ARTICLE = 'articles@replace-article';
export const ARTICLES_DELETE_ARTICLE = 'articles@delete-article';
export const ARTICLES_SET_ERROR_MESSAGE = 'articles@set-error-message';
